import React from "react";
import { VideoPreview } from "../common/VideoLightbox";
import { useHeroVideoConfig } from "../../lib/useHeroVideoConfig";
import { SectionHeader } from "./_shared";

/**
 * VideoOverview — homepage "How VenturaZ works in 90 seconds" band.
 * URL / title / duration all live in the Hero Pulse CMS
 * (`/admin/hero-pulse` → Overview Videos). Editing them there is a
 * live swap — no redeploy.
 */
export default function VideoOverview() {
  const cfg = useHeroVideoConfig("home");
  // Super Admin can temporarily hide the whole section from
  // /admin/hero-pulse without losing the URL / title / duration copy.
  if (cfg.enabled === false) return null;
  return (
    <section className="brand-section-alt border-t border-navy/[0.06]" data-testid="home-video-overview">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <SectionHeader
          eyebrow="See it in motion"
          title={cfg.title}
          subtitle="A quick walkthrough of the founder journey, investor journey, and how our diligence engine keeps both sides honest."
          testIdPrefix="home-video-overview"
        />
        <div className="mt-10 max-w-5xl mx-auto">
          <VideoPreview
            src={cfg.url || undefined}
            title={cfg.title}
            description={cfg.description}
            eyebrow="Product Tour"
            duration={cfg.duration}
            testId="home-video-overview-preview"
          />
          <p className="mt-4 text-center text-[11px] font-mono uppercase tracking-widest text-ink-muted">
            No signup needed · plays in a lightbox · closes on Esc
          </p>
        </div>
      </div>
    </section>
  );
}
